import { Box } from "@mui/material";
import PropTypes from "prop-types";

const MobileFrame = ({ children, sx = {} }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "280px",
        height: "560px",
        background: "#000",
        borderRadius: "30px",
        padding: "8px",
        mx: "auto",
        boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "20px",
          left: "20px",
          right: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          zIndex: 10,
        }}
      ></Box>

      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          borderRadius: "22px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {children}
      </Box>

      <Box
        sx={{
          position: "absolute",
          bottom: "8px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "134px",
          height: "5px",
          backgroundColor: "#fff",
          borderRadius: "3px",
          opacity: 0.3,
        }}
      />
    </Box>
  );
};

MobileFrame.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default MobileFrame;
